'use client';
import styled, { css } from 'styled-components';

export const StyledConfirmationOrderSummary = styled.div`
  width: 100%;
  background: ${props => props.theme.colors.background.lightest};
  border-radius: ${props => props.theme.spacing(7)};
  padding: ${props => props.theme.spacing(8, 4)};
  ${props => props.theme.typography.body}
  margin-top:  ${props => props.theme.spacing(6)};

  @media ${props => props.theme.tablet} {
    margin-top: ${props => props.theme.spacing(2)};
    padding: ${props => props.theme.spacing(8)};
  }

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(8)};
    border-radius: ${props => props.theme.spacing(8)};
    max-width: 375px;
  }
`;

export const OrderSummaryTitle = styled.h1`
  ${props => props.theme.typography.heading3};
  text-align: center;
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const Section = styled.div`
  margin-top: ${props => props.theme.spacing(6)};
  padding-bottom: ${props => props.theme.spacing(6)};
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.withAlpha('border.fur', 0.5)};

  &:last-of-type {
    border: none;
    padding-bottom: 0;
  }

  ${({ hideBorderBottom, theme }) =>
    hideBorderBottom
      ? css`
          border-bottom: none;
        `
      : css`
          border-bottom: 1px solid ${theme.colors.border.fur};
        `}

  ${({ smallMarginPadding, theme }) =>
    smallMarginPadding &&
    css`
      margin-top: ${theme.spacing(1)};
      padding-bottom: ${theme.spacing(1)};
    `}

  ${({ firstMarginTop, theme }) =>
    firstMarginTop &&
    css`
      margin-top: ${theme.spacing(6)};
    `}

  ${({ lastPaddingBottom, theme }) =>
    lastPaddingBottom &&
    css`
      padding-bottom: ${theme.spacing(8)};
    `}

  ${({ columns, mobileStacked }) =>
    columns === 2 &&
    css`
      display: flex;
      justify-content: space-between;
      flex-direction: ${mobileStacked ? 'column' : 'row'};

      @media ${({ theme }) => theme.tabletL} {
        flex-direction: row;
      }
    `}

  ${({ columns }) =>
    columns === 3 &&
    css`
      display: flex;
      flex-direction: column;

      @media ${({ theme }) => theme.tablet} {
        justify-content: space-between;
        flex-direction: row;
      }
    `}
`;

export const SectionTitle = styled.h4`
  position: relative;
  ${({ theme }) => theme.typography.heading4}
  font-weight: bold;
  color: ${props => props.theme.colors.text.secondary};
`;

export const SectionSubtitle = styled.h4`
  color: ${props =>
    props.color
      ? props.theme.colors.get(props.color, props.theme.colors.text.primary)
      : props.theme.colors.text.secondary};
  ${props =>
    props.value
      ? props.theme.typography.bodyBold
      : props.theme.typography.body};
  ${props => (props.heading ? props.theme.typography.subheading2 : null)}
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-top: ${props => props.theme.spacing(7)};
`;
